import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEnvelope32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconEnvelope32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25 8H7q-.075 0-.151.006l9.115 9.115 9.12-9.12zM5 10c0-.297.065-.58.181-.833L12.015 16 5.18 22.833A2 2 0 0 1 5 22zm1.849 13.994Q6.924 24 7 24h18l.084-.002-6.584-6.584-1.828 1.829-.708.707-.707-.707-1.828-1.829zM19.914 16l6.882 6.881c.13-.265.204-.565.204-.881V10c0-.316-.073-.616-.204-.882zM7 6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4V10a4 4 0 0 0-4-4z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEnvelope32);
